import { register } from "../../../JavaScript/Utils";

export interface SearchResults {
  el: HTMLElement;
}

function createSearchResults(config: SearchResults) {
  const { el } = config;

  const resultContainer = el.querySelectorAll<HTMLElement>(
    ".comp-search-results"
  );

  const resultContent: HTMLElement[] = [];
  const result: HTMLElement[] = [];

  for (let i = 0; i < resultContainer.length; i++) {
    result[i] = resultContainer[i].querySelector<HTMLElement>(
      ".comp-search-results--result-faq"
    );
    resultContent[i] = resultContainer[i].querySelector<HTMLElement>(
      ".comp-search-results--result-content"
    );
    if (result[i])
      resultContainer[i].addEventListener("click", (event) => {
        event.preventDefault();
        toggleExpandFaq(result[i], resultContent[i]);
      });
  }

  //   resultContent.style.backgroundColor = "#ff0000";

  const toggleExpandFaq = (
    DivForResultContainer: HTMLElement,
    DivForContent: HTMLElement
  ) => {
    console.log(DivForResultContainer);
    if (
      DivForResultContainer.classList.contains(
        "comp-search-results--result-faq"
      )
    ) {
      DivForResultContainer.classList.remove("comp-search-results--result-faq");
      DivForResultContainer.classList.add(
        "comp-search-results--result-faq-expanded"
      );
      DivForContent.classList.remove("comp-search-results--result-content");
      DivForContent.classList.add("comp-search-results--result-content-faq");
    } else if (
      DivForResultContainer.classList.contains(
        "comp-search-results--result-faq-expanded"
      )
    ) {
      DivForResultContainer.classList.add("comp-search-results--result-faq");
      DivForResultContainer.classList.remove(
        "comp-search-results--result-faq-expanded"
      );
      DivForContent.classList.add("comp-search-results--result-content");
      DivForContent.classList.remove("comp-search-results--result-content-faq");
    }
  };
}

export const SearchResults = async (el: HTMLElement) => {
  createSearchResults({ el });
};

register("SearchResults", SearchResults);
